"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFetchResponse = void 0;
const isAuthorization = (auth) => { var _a; return ((_a = auth === null || auth === void 0 ? void 0 : auth.Authorization) === null || _a === void 0 ? void 0 : _a.length) > 0; };
function createAuthorizationHeader(auth) {
    if (isAuthorization(auth)) {
        return Object.assign({}, auth);
    }
    if (!(auth === null || auth === void 0 ? void 0 : auth.username) || !auth.password) {
        return undefined;
    }
    const { username, password } = auth;
    return {
        Authorization: `Basic ${btoa(`${username}:${password}`)}`,
    };
}
function createFetchResponse(config) {
    const { fetch, logger = console, applicationName } = config;
    let injectedMockConfig;
    const metrics = {
        requestTimings: [],
    };
    async function fetchResponse(serviceConfig, serviceName, options = {}) {
        const url = new URL(serviceConfig.origin);
        const { auth: credentials } = serviceConfig;
        const { searchParams, headers, body } = options;
        if (serviceConfig.path) {
            url.pathname = serviceConfig.path;
        }
        if (searchParams) {
            url.search = searchParams.toString();
        }
        const headersWithAuthorization = Object.assign(Object.assign({}, createAuthorizationHeader(credentials)), headers);
        const requestInit = {};
        let methodLogMessage = "GET";
        if (body != null) {
            requestInit.method = "POST";
            if (typeof body === "string") {
                requestInit.body = body;
            }
            else if (body instanceof URLSearchParams) {
                requestInit.body = body.toString();
                headersWithAuthorization["Content-Type"] =
                    "application/x-www-form-urlencoded";
            }
            else {
                requestInit.body = JSON.stringify(body);
                headersWithAuthorization["Content-Type"] = "application/json";
            }
            methodLogMessage = `POST (${headersWithAuthorization["Content-Type"]})`;
        }
        if (injectedMockConfig &&
            injectedMockConfig.mockIds.length > 0 &&
            injectedMockConfig.mocksServerConfig) {
            const { mockIds, mocksServerConfig } = injectedMockConfig;
            const mockRequest = {
                originalRequest: {
                    href: url.href,
                    headers: headersWithAuthorization,
                },
                serviceName,
                mockIds,
                applicationName,
            };
            const mockUrl = new URL(mocksServerConfig.baseUrl);
            mockUrl.searchParams.set("mockRequest", JSON.stringify(mockRequest));
            const startTime = Date.now();
            try {
                return await fetch(mockUrl.href, Object.assign({ headers: createAuthorizationHeader(mocksServerConfig.auth) }, requestInit));
            }
            catch (error) {
                logger.error("Error while fetching data:", url.href, error);
                return;
            }
            finally {
                const endTime = Date.now();
                metrics.requestTimings.push({
                    service: serviceName,
                    path: serviceConfig.path || "/",
                    start: startTime,
                    end: endTime,
                });
                logger.debug(`Fetched ${serviceName} mock data as ${methodLogMessage} from ${mockUrl.href} via ${mockRequest.originalRequest.href}: ${endTime - startTime}ms`);
            }
        }
        else {
            const startTime = Date.now();
            try {
                return await fetch(url.href, Object.assign({ headers: headersWithAuthorization }, requestInit));
            }
            catch (error) {
                logger.error("Error while fetching data:", url.href, error);
                return;
            }
            finally {
                const endTime = Date.now();
                metrics.requestTimings.push({
                    service: serviceName,
                    path: serviceConfig.path || "/",
                    start: startTime,
                    end: endTime,
                });
                logger.debug(`Fetched ${serviceName} data as ${methodLogMessage} from ${url.href}: ${endTime - startTime}ms`);
            }
        }
    }
    fetchResponse.initialize = (mockConfig) => {
        injectedMockConfig = mockConfig;
        metrics.requestTimings = [];
        if (mockConfig.mockIds.length > 0 && mockConfig.mocksServerConfig) {
            logger.info(`Initialized fetch-json with mockIds: [${mockConfig.mockIds.join(", ")}]`);
        }
        else {
            logger.info("Initialized fetch-json without mocks!");
        }
    };
    fetchResponse.getMetrics = () => {
        return metrics;
    };
    return fetchResponse;
}
exports.createFetchResponse = createFetchResponse;
